import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasComunesService from 'services/tablasComunes.service'

const TipoDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [documentosOptions, setDocumentosOptions] = React.useState([])

  const selectRef = React.useRef(null)

  React.useEffect(() => {
    TablasComunesService.getAsSelect(TiposTablaComunConstant.DOCUMENTOSUNAT).then(({ data }) => {
      if (data && data.length > 0) {
        setDocumentosOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.nombre}
            </option>
          ))
        )
      }
    })
  }, [])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-infonota-buscar', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='CODIGO' htmlFor='select-tipoDocumentoBusqueda' md={12} />
      <Col md={12}>
        <Field name='tipoDocumentoBusqueda'>
          {({ field }) => (
            <Form.Select
              {...field}
              ref={selectRef}
              id='select-tipoDocumentoBusqueda'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            >
              <option value=''>Seleccionar</option>
              {documentosOptions}
            </Form.Select>
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
